/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { PageInfoDto } from '../models/page-info-dto';
import { postAdminControllerCreateV1 } from '../fn/post-admin/post-admin-controller-create-v-1';
import { PostAdminControllerCreateV1$Params } from '../fn/post-admin/post-admin-controller-create-v-1';
import { postAdminControllerDeleteV1 } from '../fn/post-admin/post-admin-controller-delete-v-1';
import { PostAdminControllerDeleteV1$Params } from '../fn/post-admin/post-admin-controller-delete-v-1';
import { postAdminControllerFindByIdV1 } from '../fn/post-admin/post-admin-controller-find-by-id-v-1';
import { PostAdminControllerFindByIdV1$Params } from '../fn/post-admin/post-admin-controller-find-by-id-v-1';
import { postAdminControllerSearchV1 } from '../fn/post-admin/post-admin-controller-search-v-1';
import { PostAdminControllerSearchV1$Params } from '../fn/post-admin/post-admin-controller-search-v-1';
import { postAdminControllerToggleExposureV1 } from '../fn/post-admin/post-admin-controller-toggle-exposure-v-1';
import { PostAdminControllerToggleExposureV1$Params } from '../fn/post-admin/post-admin-controller-toggle-exposure-v-1';
import { postAdminControllerUpdateV1 } from '../fn/post-admin/post-admin-controller-update-v-1';
import { PostAdminControllerUpdateV1$Params } from '../fn/post-admin/post-admin-controller-update-v-1';
import { PostDto } from '../models/post-dto';

@Injectable({ providedIn: 'root' })
export class PostAdminService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postAdminControllerSearchV1()` */
  static readonly PostAdminControllerSearchV1Path = '/api/v1/posts/admin/search/offset';

  /**
   * 게시글 검색 (오프셋).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdminControllerSearchV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerSearchV1$Response(params: PostAdminControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'items': Array<PostDto>;
'pageInfo': PageInfoDto;
}>> {
    const obs = postAdminControllerSearchV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 게시글 검색 (오프셋).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdminControllerSearchV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerSearchV1(params: PostAdminControllerSearchV1$Params, context?: HttpContext): Observable<{
'items': Array<PostDto>;
'pageInfo': PageInfoDto;
}> {
    const resp = this.postAdminControllerSearchV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
'items': Array<PostDto>;
'pageInfo': PageInfoDto;
}>): {
'items': Array<PostDto>;
'pageInfo': PageInfoDto;
} => r.body)
    );
  }

  /** Path part for operation `postAdminControllerFindByIdV1()` */
  static readonly PostAdminControllerFindByIdV1Path = '/api/v1/posts/admin/{id}';

  /**
   * 게시글 상세 조회.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdminControllerFindByIdV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerFindByIdV1$Response(params: PostAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PostDto>> {
    const obs = postAdminControllerFindByIdV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 게시글 상세 조회.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdminControllerFindByIdV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerFindByIdV1(params: PostAdminControllerFindByIdV1$Params, context?: HttpContext): Observable<PostDto> {
    const resp = this.postAdminControllerFindByIdV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PostDto>): PostDto => r.body)
    );
  }

  /** Path part for operation `postAdminControllerDeleteV1()` */
  static readonly PostAdminControllerDeleteV1Path = '/api/v1/posts/admin/{id}';

  /**
   * 게시글 삭제.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdminControllerDeleteV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerDeleteV1$Response(params: PostAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PostDto>> {
    const obs = postAdminControllerDeleteV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 게시글 삭제.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdminControllerDeleteV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerDeleteV1(params: PostAdminControllerDeleteV1$Params, context?: HttpContext): Observable<PostDto> {
    const resp = this.postAdminControllerDeleteV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PostDto>): PostDto => r.body)
    );
  }

  /** Path part for operation `postAdminControllerUpdateV1()` */
  static readonly PostAdminControllerUpdateV1Path = '/api/v1/posts/admin/{id}';

  /**
   * 게시글 수정.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdminControllerUpdateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdminControllerUpdateV1$Response(params: PostAdminControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PostDto>> {
    const obs = postAdminControllerUpdateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 게시글 수정.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdminControllerUpdateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdminControllerUpdateV1(params: PostAdminControllerUpdateV1$Params, context?: HttpContext): Observable<PostDto> {
    const resp = this.postAdminControllerUpdateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PostDto>): PostDto => r.body)
    );
  }

  /** Path part for operation `postAdminControllerCreateV1()` */
  static readonly PostAdminControllerCreateV1Path = '/api/v1/posts/admin';

  /**
   * 게시글 생성.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdminControllerCreateV1()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdminControllerCreateV1$Response(params: PostAdminControllerCreateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<PostDto>> {
    const obs = postAdminControllerCreateV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 게시글 생성.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdminControllerCreateV1$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  postAdminControllerCreateV1(params: PostAdminControllerCreateV1$Params, context?: HttpContext): Observable<PostDto> {
    const resp = this.postAdminControllerCreateV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PostDto>): PostDto => r.body)
    );
  }

  /** Path part for operation `postAdminControllerToggleExposureV1()` */
  static readonly PostAdminControllerToggleExposureV1Path = '/api/v1/posts/admin/{id}/toggle-exposure';

  /**
   * 게시글 노출/비노출 토글.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postAdminControllerToggleExposureV1()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerToggleExposureV1$Response(params: PostAdminControllerToggleExposureV1$Params, context?: HttpContext): Observable<StrictHttpResponse<boolean>> {
    const obs = postAdminControllerToggleExposureV1(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * 게시글 노출/비노출 토글.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postAdminControllerToggleExposureV1$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postAdminControllerToggleExposureV1(params: PostAdminControllerToggleExposureV1$Params, context?: HttpContext): Observable<boolean> {
    const resp = this.postAdminControllerToggleExposureV1$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<boolean>): boolean => r.body)
    );
  }

}
